import { render, staticRenderFns } from "./FlipkartLqsCard.vue?vue&type=template&id=05094454&scoped=true"
import script from "./FlipkartLqsCard.vue?vue&type=script&lang=js"
export * from "./FlipkartLqsCard.vue?vue&type=script&lang=js"
import style0 from "./FlipkartLqsCard.vue?vue&type=style&index=0&id=05094454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05094454",
  null
  
)

export default component.exports